import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Common.questionDeleteItem'),
      "open": _vm.cascadePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'danger',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.cascadePrompt = false;
      },
      "cancel": function ($event) {
        _vm.cascadePrompt = false;
      },
      "delete": function ($event) {
        return _vm.confirmCascadeDelete();
      }
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Connectors.cascadePrompt.usedByTitle')))]), _c('ul', {
    staticStyle: {
      "padding-left": "18px",
      "margin": "0"
    }
  }, _vm._l(_vm.cascadeFlows, function (flow) {
    return _c('li', {
      key: flow.id,
      staticStyle: {
        "margin-bottom": "4px"
      }
    }, [_c('router-link', {
      attrs: {
        "to": `/connectors/consumers/list?openFlowId=${flow.id}`
      }
    }, [_vm._v("\n          " + _vm._s(flow.name) + " (#" + _vm._s(flow.id) + ")\n        ")])], 1);
  }), 0), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Connectors.cascadePrompt.deleteAllConfirm')))])]), _c('core-prompt', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Common.areYouSure'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'danger',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.deletePrompt = false;
      },
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.deleteTransformer(_vm.deleteItemId);
      }
    }
  }, [_vm._v("\n    " + _vm._s((_vm.transformers.find(t => t.id === _vm.deleteItemId) || {}).name) + "\n  ")]), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Connectors.Transformer.title'),
      "subtitle": _vm.$i18n_t('Connectors.Transformer.description')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "accounts-loaded": function ($event) {
              _vm.loadingAccounts = false;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              return _vm.openEdit();
            }
          }
        }, [!_vm.isMobile ? [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.create')) + "\n        ")] : _vm._e()], 2)];
      },
      proxy: true
    }])
  }), !_vm.loadingAccounts ? _c('div', {
    staticClass: "n20-mainrow pt-4"
  }, [!_vm.loadingAccounts ? _c('core-n20Card', [!_vm.isLoading && _vm.hasNoTransformers ? _c('core-empty-state', {
    attrs: {
      "icon": "fa-random",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Transformer.emptyState.title')) + "\n        ")];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_c('core-button', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "append-icon": "fa-arrow-right"
          },
          on: {
            "click": function ($event) {
              return _vm.openEdit();
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Transformer.emptyState.button')) + "\n          ")])];
      },
      proxy: true
    }], null, false, 1170712569)
  }, [_c('p', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Connectors.Transformer.emptyState.description')) + "\n        ")])]) : [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": "",
      "data-cy": "searchTransformation"
    },
    on: {
      "click:clear": function ($event) {
        _vm.searchItem = '';
      }
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  }), _c(VDataTable, {
    attrs: {
      "items": _vm.transformers,
      "search": _vm.searchItem,
      "loading": _vm.isLoading,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.footerProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n          ")];
      }
    }, {
      key: "item.tenantId",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s((_vm.accounts.find(account => account.id === item.tenantId) || {}).name) + "\n          ")];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "data-cy": "edit_btn"
          },
          on: {
            "click": function ($event) {
              return _vm.openEdit(item);
            }
          }
        }, [_vm._v("fal fa-edit")]), _vm._v("\n             \n            "), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": "",
            "data-cy": "delete_btn"
          },
          on: {
            "click": function ($event) {
              return _vm.showDeletePrompt(item.id);
            }
          }
        }, [_vm._v("\n              fal fa-trash-alt\n            ")])];
      }
    }], null, false, 877271124)
  })]], 2) : _vm._e(), _c('br'), _c('br')], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };